import { useLayoutEffect, useEffect } from 'react';
import { isServer } from '@doda/common/src/utils/isServer';

export const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;
